var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6.37a.27.27 0 00-.27.28.27.27 0 10.27-.28M6.92 12a.27.27 0 10-.55 0 .27.27 0 00.55 0m9.06-3.98a.27.27 0 10-.39.39.27.27 0 00.39-.39m-7.57 7.57a.27.27 0 10-.39.39.27.27 0 00.39-.4m0-7.17c.1-.1.1-.28 0-.39a.27.27 0 100 .39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21a9 9 0 01-9-9.26A9.1 9.1 0 0111.74 3 9 9 0 0121 12v1a2 2 0 01-2 2h-2.06A2 2 0 0015 17.55l.26.9A2 2 0 0113.35 21H12z",
    clipRule: "evenodd"
  }))));
}
export default SvgColor;